import "./styles.css";

const Loading = () => {
  return (
    <div className="loading-box">
      <div className="loading-circle"></div>
      <div className="loading-circle"></div>
      <div className="loading-circle"></div>
    </div>
  );
};

export default Loading;
